import { RequireSubmissionProvided } from "../../../../../wrappers/requireSubmission";
import { useEffect, useMemo } from "react";
import { SubmissionData2026CHM, SubmissionData2026CHMAddon, isPending, isSubmissionData2026, updateSubmission } from "../../../../../reduxToolkit/submissionsSlice";
import { useAppDispatch } from "../../../../../hooks/reduxToolkit";
import { SubmissionInstructions2026 } from "./submissionInstructions2026";

export interface SubmitToCHM2026Props extends RequireSubmissionProvided {
}

export function SubmitToChm2026({ submission }: SubmitToCHM2026Props) {
  const dispatch = useAppDispatch()

  // Initialize or get submission data
  const data = useMemo((): SubmissionData2026CHM | SubmissionData2026CHMAddon => {
    if (isSubmissionData2026(submission.data)) {
      return submission.data as SubmissionData2026CHM | SubmissionData2026CHMAddon
    }

    // Initialize new 2026 submission data
    const initialData: SubmissionData2026CHM | SubmissionData2026CHMAddon =
      submission.submission_type === 'CHM-addon'
        ? {
            _version: '2026-01-01',
            type: 'addon',
            instructionsShown: true
          }
        : {
            _version: '2026-01-01',
            type: 'CHM',
            instructionsShown: true
          }

    return initialData
  }, [submission.data, submission.submission_type])

  // Update submission data on mount if needed - mark instructions as shown
  // since the progress bar already ran on the home page.
  // Only for submissions still in progress: an already-submitted record may carry a pre-2026
  // `data` payload (`SubmissionDataV0`, or a 2023/2024 shape not caught by the normalizing
  // migration), and rewriting it would destroy history for a row nobody is resuming.
  useEffect(() => {
    if (isPending(submission) && (!submission.data || !isSubmissionData2026(submission.data))) {
      const now = new Date().toISOString()
      dispatch(updateSubmission({
        id: submission.id,
        data: {
          ...data,
          instructionsShown: true
        },
        updated_at: now
      }))
    }
  }, [submission.id, submission.data, data, dispatch])

  return <SubmissionInstructions2026 submission={submission} data={data} />
}
